import script from "./AddNoteTypeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNoteTypeForm.vue?vue&type=script&setup=true&lang=js"

import "./AddNoteTypeForm.vue?vue&type=style&index=0&id=248b8cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-248b8cfc"]])

export default __exports__